import agGridStyles from './agGrid.styles';
import agGridThemeStyles from './agGridTheme.styles';
import agGridThemeFm from './agGridThemeFm.styles';
import cellsStyles from '../cells/styles/index';
import headerCellsStyles from '../headerCells/styles/index';
import tooltipStyles from './tooltipStyles';
import popoverStyles from './popoverStyles';
import { FIELD_SELECTOR_SPACER_COL_ID, FIELD_SELECTOR_SPACER_WIDTH } from '../utils/agGridColumn';

export default (theme) => ({
    '@keyframes spin': {
        from: {
            transform: 'rotate(0deg)',
        },
        to: {
            transform: 'rotate(360deg)',
        },
    },
    '@keyframes ag-shake-left-to-right': {
        from: {
            paddingLeft: 6,
            paddingRight: 2,
        },
        to: {
            paddingLeft: 2,
            paddingRight: 6,
        },
    },
    '@font-face': {
        fontFamily: '"agGridBalham"',
        src: 'url("data:application/x-font-ttf;charset=utf-8;base64,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") format("truetype")',
        fontWeight: 'normal',
        fontStyle: 'normal',
    },
    root: {
        // AG Grid --ag-* tokens: see agGridThemeVariables.js (applied on &.ag-theme-balham
        // and .ag-root-wrapper with specificity above ag-grid.css [class*=ag-theme-]).
        position: 'relative',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        height: '100%',
        minHeight: 0,
        ...agGridStyles(theme),
        ...agGridThemeStyles(theme),
        ...agGridThemeFm(theme),
        ...cellsStyles(theme),
        ...headerCellsStyles(theme),
        ...popoverStyles(theme),
        fontFamily: theme.typography.fontFamily,
        '&.w5-grid-group-rows-static': {
            '& .ag-row': {
                transition: 'none !important',
            },
            '& .ag-row .ag-cell': {
                transition: 'none !important',
            },
        },
        // Spacer column reserves header width; absolute fieldSelector covers that slot.
        // AG Grid 36 creates data-less rows while an infinite block is pending.
        // Hide those placeholders even during the frame where overlay DOM is swapped.
        '& .ag-row.ag-row-loading, & .ag-row.w5-row-loading': {
            visibility: 'hidden',
            pointerEvents: 'none',
        },
        '&$hasFieldSelector': {
            [`& .ag-header-cell[col-id="${FIELD_SELECTOR_SPACER_COL_ID}"]`]: {
                visibility: 'hidden',
                pointerEvents: 'none',
                border: 'none !important',
                padding: '0 !important',
                background: 'transparent !important',
            },
            [`& .ag-header-cell[col-id="${FIELD_SELECTOR_SPACER_COL_ID}"] .ag-header-cell-resize`]:
                {
                    display: 'none',
                },
            '& .ag-header-cell.w5-header--field-selector-last-data .ag-header-cell-resize': {
                pointerEvents: 'auto',
                zIndex: 6,
            },
            '& .ag-header-cell.w5-header--field-selector-last-data.w5-header--hover:hover .ag-header-cell-resize':
                {
                    right: '1px',
                    cursor: 'e-resize',
                    borderRight: `2px solid ${theme.colors.grey[400]}`,
                    '&:active': {
                        borderRight: `2px solid ${theme.colors.semantic.info500}`,
                    },
                },
            '& .ag-header-cell.w5-header--field-selector-last-data.ag-header-cell-last-left-pinned.w5-header--hover:hover':
                {
                    borderRightColor: 'transparent',
                    '& .ag-header-cell-resize': {
                        right: 0,
                    },
                },
        },
    },
    hasFieldSelector: {},
    autoHeightRoot: {
        height: 'auto',
    },
    isPositioningColumns: {
        // Keep the scrollbar lane in the layout while AG Grid measures and positions columns.
        // display: none changes the viewport width and recreates the layout flicker.
        '& .ag-root > .ag-body-horizontal-scroll': {
            visibility: 'hidden',
            pointerEvents: 'none',
        },
    },
    gridSurface: {
        flex: '1 1 auto',
        minHeight: 0,
        minWidth: 0,
        width: '100%',
        height: '100%',
        position: 'relative',
    },
    '@keyframes spinAnimation': {
        to: {
            transform: 'rotate(360deg)',
            '-webkit-transform': 'rotate(360deg)',
        },
    },
    fieldSelector: {
        display: 'flex',
        position: 'absolute',
        zIndex: 5,
        right: '0',
        top: '0',
        width: FIELD_SELECTOR_SPACER_WIDTH,
        boxSizing: 'border-box',
        height: '39px', // matching table header border
        marginTop: 1,
        marginRight: 1,
        borderTopRightRadius: '6px',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '0 10px',
        backgroundColor: theme.colors.actionMinor[50],
        cursor: 'pointer',
        pointerEvents: 'none',
        '& > *': {
            pointerEvents: 'auto',
        },
    },
    fieldSelectorIcon: {
        borderRadius: 3,
        color: theme.colors.actionMinor[500],
        '& svg': {
            width: 24,
            height: 24,
        },
        '&:hover': {
            color: theme.colors.actionMinor[600],
            backgroundColor: theme.colors.actionMinor[100],
        },
    },
    fieldSelectorIconActive: {
        backgroundColor: `${theme.colors.actionMinor[100]} !important`,
    },
    fieldSelectorPopover: {
        width: 346,
        maxHeight: '400px',
        overflow: 'auto',
        padding: '0 !important',
        borderRadius: '4px',
        boxShadow:
            '0px 8px 10px rgba(39, 60, 80, 0.14), 0px 3px 14px rgba(39, 60, 80, 0.12), 0px 4px 5px rgba(39, 60, 80, 0.2)',
        backgroundColor: theme.colors.primary.white,
        '&::-webkit-scrollbar': {
            width: 12,
            height: 12,
        },
        '&::-webkit-scrollbar-thumb': {
            borderRadius: 10,
            background: theme.colors.grey[200],
            backgroundClip: 'content-box',
            border: '2px solid rgba(0, 0, 0, 0)',
        },
        '&::-webkit-scrollbar-thumb:window-inactive': {
            borderRadius: 10,
            background: theme.colors.grey[200],
            backgroundClip: 'content-box',
            border: '2px solid rgba(0, 0, 0, 0)',
        },
        '& .hoi-poi-popover-inner': {
            padding: '0px',
            boxShadow: 'none',
        },
    },
    fieldSelectorPopoverContent: {
        width: 346,
        boxSizing: 'border-box',
        textOverflow: 'ellipsis',
        '& .data-grid-field-selector__actions': {
            padding: '8px 16px',
        },
        '& .data-grid-field-selector__action': {
            ...theme.typography.body,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-start',
            color: theme.colors.utility.textPrimary,
            backgroundColor: 'transparent',
            cursor: 'pointer',
            padding: '8px 16px 8px 12px',
            transition: 'all .2s ease',
            '&:hover': {
                backgroundColor: theme.colors.actionMinor[50],
            },
        },
        '& .data-grid-field-selector__action--disabled': {
            opacity: 0.4,
            pointerEvents: 'none',
        },
        '& .data-grid-field-selector__action__icon': {
            color: theme.colors.grey[500],
            width: '18px',
            height: '18px',
            marginRight: '12px',
        },
        '& .data-grid-field-selector__action__label:only-child': {
            paddingLeft: '30px',
        },
        '& .data-grid-field-selector__divider': {
            height: '1px',
            backgroundColor: theme.colors.grey[100],
            margin: '8px 0',
        },
        '& .data-grid-field-selector__title': {
            ...theme.typography.subtitle,
            fontWeight: 500,
            color: theme.colors.utility.textPrimary,
            padding: '6px 0',
        },
    },
    isEmpty: {
        '& .ag-grid-scrolling-container > .ag-row': {
            visibility: 'hidden',
        },
        // v36 also adds ag-body-horizontal-scroll as a state class on .ag-root.
        // Target only the dedicated scrollbar child or the selector hides the whole grid.
        '& .ag-root > .ag-body-horizontal-scroll': {
            display: 'none !important',
        },
        '& .ag-overlay-wrapper:not(.ag-overlay-loading-wrapper)': {
            display: 'flex',
        },
    },
    isLoading: {
        '& .ag-overlay-wrapper.ag-overlay-loading-wrapper': {
            display: 'flex',
            pointerEvents: 'all',
            alignItems: 'stretch',
            justifyContent: 'flex-start',
            height: '100%',
            // Stable from first paint — AG Grid sets padding-top async (0 → headerHeight) which
            // resizes the skeleton. Our skeleton is CSS-only and fills the content box below.
            paddingTop: 'var(--ag-header-height, 40px) !important',
            '& .ag-react-container': {
                display: 'block !important',
                width: '100%',
                height: '100%',
            },
        },
        '& .ag-overlay-wrapper:not(.ag-overlay-loading-wrapper)': {
            display: 'none !important',
        },
        '& .ag-overlay-panel': {
            height: '100%',
        },
        // v36: header is a child of .ag-grid-pinned-top-rows. Keep that lane sized while loading.
        '& .ag-grid-pinned-top-rows': {
            flex: '0 0 auto',
            minHeight: 'var(--ag-header-rows-height, var(--ag-header-height, 40px))',
        },
        '& .ag-header': {
            zIndex: 5,
        },
        '& $fieldSelector': {
            display: 'none',
        },
    },
    '@global': {
        body: {
            ...tooltipStyles(theme),
            '& .ag-dnd-ghost': {
                display: 'flex',
                alignItems: 'center',
                background: '#e5e5e5',
                border: '1px solid black',
                cursor: 'move',
                fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
                fontSize: 14,
                lineHeight: '1.4',
                overflow: 'hidden',
                padding: 3,
                position: 'absolute',
                textOverflow: 'ellipsis',
                userSelect: 'none',
                zIndex: '10',
                opacity: 0,
                '&.ag-dnd-ghost--visible': {
                    opacity: 1,
                },
            },
            '& .ag-dnd-ghost-icon': {
                padding: 2,
            },
            '& .ag-theme-balham.ag-dnd-ghost': {
                background: 'white',
                borderRadius: 2,
                boxShadow: 'none',
                padding: '0 8px',
                border: `1px solid ${theme.colors.grey[100]}`,
                color: 'rgba(0, 0, 0, 0.54)',
                fontWeight: '600',
                fontSize: 12,
                fontFamily:
                    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen-Sans, Ubuntu, Cantarell, "Helvetica Neue", sans-serif',
                height: '32px !important',
                lineHeight: '32px',
                margin: '0',
                transform: 'translateY(8px)',
            },
            '& .ag-theme-balham.ag-dnd-ghost span, & .ag-theme-balham.ag-dnd-ghost div': {
                height: '100%',
                margin: '0',
                padding: '0',
            },
            '& .ag-theme-balham.ag-dnd-ghost .ag-dnd-ghost-icon': {
                marginRight: 4,
                opacity: '0.87',
            },
            '& #w5-drag-preview': {
                position: 'fixed',
            },
            '& .w5-drag-over': {
                transition: 'all 0.15s',
                backgroundImage: `repeating-linear-gradient(0deg, ${theme.colors.semantic.info500}, ${theme.colors.semantic.info500} 5px, transparent 5px, transparent 10px, ${theme.colors.semantic.info500} 10px), repeating-linear-gradient(90deg, ${theme.colors.semantic.info500}, ${theme.colors.semantic.info500} 5px, transparent 5px, transparent 10px, ${theme.colors.semantic.info500} 10px), repeating-linear-gradient(180deg, ${theme.colors.semantic.info500}, ${theme.colors.semantic.info500} 5px, transparent 5px, transparent 10px, ${theme.colors.semantic.info500} 10px), repeating-linear-gradient(270deg, ${theme.colors.semantic.info500}, ${theme.colors.semantic.info500} 5px, transparent 5px, transparent 10px, ${theme.colors.semantic.info500} 10px) !important`,
                backgroundSize: '1px 100%, 100% 1px, 1px 100% , 100% 1px',
                backgroundPosition: '0 0, 0 0, 100% 0, 0 100%',
                backgroundRepeat: 'no-repeat',
                backgroundColor: `${theme.colors.semantic.infoCustom50} !important`,
                boxSizing: 'border-box !important',
                zIndex: 2,
                '& *': {
                    pointerEvents: 'none !important',
                },
            },
        },
    },
});
